<template>
  <footer v-reveal class="portal-footer">
    <div class="container footer-inner">
      <div class="footer-top">
        <div class="footer-brand">
          <img src="/favicon.png" alt="笔芯科研" class="brand-icon" />
          <div>
            <strong class="brand-name">笔芯科研</strong>
            <p>专业降重 · 降AIGC · 双降平台</p>
          </div>
        </div>
        <div class="footer-links">
          <router-link to="/">功能介绍</router-link>
          <router-link to="/pricing">套餐价格</router-link>
          <router-link to="/faq">常见问题</router-link>
          <router-link to="/about">关于我们</router-link>
        </div>
      </div>
      <div class="footer-meta">
        <span>支持知网、维普、万方等主流检测平台</span>
        <span>客服邮箱：bixinpaper@126.com</span>
      </div>
      <div class="footer-copy">
        <span>© 2026 笔芯科研 版权所有</span>
        <a
          class="icp-link"
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noopener noreferrer">
          宁ICP备2026002873号-2
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'PortalFooter'
}
</script>

<style scoped>
.portal-footer {
  margin-top: 80px;
  padding: 48px 0 32px;
  background: #f9fafb;
  border-top: 1px solid #eef0f4;
}

.footer-inner {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.footer-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
}

.footer-brand {
  display: flex;
  align-items: center;
  gap: 12px;
}

.brand-icon {
  width: 40px;
  height: 40px;
  object-fit: contain;
  display: block;
  flex-shrink: 0;
}

.footer-brand p {
  margin: 4px 0 0;
  color: var(--text-secondary);
  font-size: 14px;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.footer-links a {
  color: var(--text-secondary);
  font-size: 14px;
  position: relative;
  transition: color 0.25s ease;
}

.footer-links a::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -2px;
  width: 100%;
  height: 1px;
  background: var(--primary);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.footer-links a:hover {
  color: var(--primary);
}

.footer-links a:hover::after {
  transform: scaleX(1);
}

.footer-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 24px;
  color: var(--text-secondary);
  font-size: 14px;
}

.footer-copy {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 16px;
  color: #999;
  font-size: 13px;
}

.icp-link {
  color: #999;
  transition: color 0.2s ease;
}

.icp-link:hover {
  color: var(--text-secondary);
}
</style>
